export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail hoặc username',
      invalidEmailOrUsername: 'Sai e-mail or username',
      invalidPassword: 'Sai mật khẩu',
      logInToWowOrder: 'Đăng nhập',
      noInternetConnection: 'Mất kết nối mạng',
      pageNotFound_title: 'Không tìm thấy trang',
      password: 'Mật khẩu',
      businessManagement: 'Quản lý business',
      serverConnectionFailed: 'Mất kết nối đến server',
      unknownError: 'Lỗi! Hãy thử lại sau',
      userDisble: 'User đã bị khoá',
    },

    action: {
      logIn: 'Đăng nhập',
    },
  },
};
